module.exports = __webpack_public_path__ + "Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.c0cc9c92fb877993ea6d.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.woff2
// module id = ../../../../../src/assets/fonts/font-google/Hgo13k-tfSpn0qi1SFdUfZBw1xU1rKptJj_0jans920.woff2
// module chunks = 40